import { routes } from '../config/api_routes'

export const dealService = {

    getProducts: () => {
        return window.axios.post(routes.getProductListApi);
    },

    getSubProducts: (formData) => {
        return window.axios.post(routes.getSubProductListApi,formData);
    },

    storeDeal: (formData) => {    
        return window.axios.post(routes.storeDealApi,formData);
    },
    getDeals: (formData) => {
        return window.axios.post(routes.getDealListApi,formData);
    },

    deleteDeal: (formData) => {
        return window.axios.post(routes.deleteDealApi,formData);
    },

    getDealById: (formData) => {
        return window.axios.post(routes.getDealById,formData);
    },

    updateDeal: (formData) => {
        return window.axios.post(routes.updateDeal,formData);
    },

    sendNotifications: (formData) => {
        return window.axios.post(routes.sendNotificationsForDeals,formData);
    }

}